<template>
    <master-page>
        <br/>
        <v-card>
            <v-card-title style="background: var(--v-primary-base); position: sticky; top: 75px; z-index: 1; color: white !important">
                <v-icon large left style="color: white">mdi-account-group</v-icon>
                <span class="title font-weight-light">Configuração do Relatório de Recurso Pessoal</span>
                <v-spacer/>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn fab small depressed="" color="primary" class="mr-2" @click="GerarRelatorio()" v-on="on"><v-icon>mdi-text-box-check</v-icon></v-btn>
                    </template>
                    <span>Gerar Relatório</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn fab small depressed="" color="primary" class="mr-2" @click="LimparFiltros()" v-on="on"><v-icon>mdi-eraser</v-icon></v-btn>
                    </template>
                    <span>Limpar</span>
                </v-tooltip>
            </v-card-title>
            <v-card-text class="mt-3">
                <v-row>
                    <v-col cols="12" sm="6" md="3">
                        <v-select v-model="filtro.etnia" label="Etnia" placeholder="SELECIONAR" :items="etnias" item-value="key" item-text="value" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-select v-model="filtro.sexo" label="Gênero" placeholder="SELECIONAR" :items="sexos" item-value="key" item-text="value" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="5">
                        <v-select v-model="filtro.escolaridade" label="Escolaridade" placeholder="SELECIONAR" :items="escolaridades" item-value="key" item-text="value" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3" lg="2">
                        <v-switch v-model="filtro.exportarExcel" label="Exportar para Excel" style="margin-top: 3px"/>
                    </v-col>
                    
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="filtro.cargo" label="Cargo" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-select v-model="filtro.tipoRegime" label="Tipo Regime" placeholder="SELECIONAR" :items="regimes" item-value="key" item-text="value" dense outlined/>
                    </v-col>

                    <v-col cols="12" sm="4" md="4">
                        <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                            <template v-slot:activator="{on}">
                                <v-text-field type="date" v-model="filtro.adesaoInicial" label="Data Adesão (Inicio)" dense outlined>
                                    <template v-slot:prepend>
                                        <v-icon v-on="on">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker locale="pt-br" v-model="filtro.adesaoInicial" no-title/>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                            <template v-slot:activator="{on}">
                                <v-text-field type="date" v-model="filtro.adesaoFinal" label="Data Adesão (Final)" dense outlined>
                                    <template v-slot:prepend>
                                        <v-icon v-on="on">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker locale="pt-br" v-model="filtro.adesaoFinal" no-title/>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-select v-model="filtro.ativo" label="Situação" placeholder="SELECIONAR" :items="ativos" item-value="key" item-text="value" dense outlined/>
                    </v-col>
                </v-row>    
                <v-row>
                    <v-col cols="12" sm="2" md="2">
                        <v-switch v-model="filtro.vincularProjeto" label="Vincular Projeto" style="margin-top: 5px"/>
                    </v-col>
                    <v-col cols="12" sm="5" md="5">
                        <v-autocomplete :disabled="!filtro.vincularProjeto" v-model="filtro.idProjeto" :items="projetos" :loading="isProjetoLoading" :search-input.sync="onSearchProjeto" clearable
                            item-text="codigoNome" item-value="id" label="Projeto" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="5" md="5">
                        <v-select :disabled="!filtro.vincularProjeto" v-model="filtro.idTipoProjeto" label="Tipo Projeto" placeholder="SELECIONAR" :items="tipoProjetos" item-value="id" item-text="nome" dense outlined/>
                    </v-col>
                </v-row>            
            </v-card-text>
        </v-card>
    </master-page>
</template>

<script>
import { EscolaridadeEnumService, EtniaEnumService, SexoEnumService, TipoRegimeEnumService } from '../../../core/services/geral';
import { PessoalService, ProjetoService, TipoProjetoService } from '../../../core/services/projetos';
import JSONToCSVConverter from '../../../assets/js/custom'

export default {
    data: () => ({
        filtro: {
            vincularProjeto: false,
            cargo: null,
            escolaridade: null,
            idProjeto: null,
            idTipoProjeto: null,
            tipoRegime: null,
            ativo: null,
            etnia: null,
            sexo: null,
            adesaoInicial: null,
            adesaoFinal: null,
            exportarExcel: false
        },        
        regimes: [],  
        regimeSerive: new TipoRegimeEnumService(),
        serive: new PessoalService(),
        projetos: [],
        projetoService: new ProjetoService(),
        isProjetoLoading: false,
        onSearchProjeto: null,
        tipoProjetos: [],
        tipoProjetoService: new TipoProjetoService(),
        etnias: [],
        etniaService: new EtniaEnumService(),
        sexos: [],
        sexoService: new SexoEnumService(),
        escolaridades: [],
        escolaridadeService: new EscolaridadeEnumService(),
        ativos: [
            { key: null, value: "TODOS" },
            { key: true, value: "ATIVO" },
            { key: false, value: "INATIVO" }
        ]
    }),
    methods: {
        GerarRelatorio(){
            if(this.filtro.exportarExcel){
                this.serive.Relatorio(this.filtro.vincularProjeto, this.filtro.cargo, this.filtro.idProjeto, this.filtro.idTipoProjeto, this.filtro.tipoRegime, this.filtro.ativo, this.filtro.etnia, this.filtro.escolaridade, this.filtro.sexo, this.filtro.adesaoInicial, this.filtro.adesaoFinal).then(
                    res=>{
                        if(this.filtro.vincularProjeto){
                            var data = res.data.item1;
                            var i = 0;
                            for(i; i< data.length; i++){
                                delete data[i]['tipo'];
                                delete data[i]['tipoRegime'];
                                delete data[i]['sexo'];
                                delete data[i]['escolaridade'];
                            }
                            if(i == data.length){
                                JSONToCSVConverter(data, "Relatorio_RecursoPessoal", true);
                            }
                        }
                        else{
                            var data = res.data.item1;
                            var i = 0;
                            for(i; i< data.length; i++){
                                delete data[i]['tipo'];
                                delete data[i]['projeto'];
                                delete data[i]['tipoProjeto'];
                                delete data[i]['tipoRegime'];
                                delete data[i]['sexo'];
                                delete data[i]['escolaridade'];
                            }
                            if(i == data.length){
                                JSONToCSVConverter(data, "Relatorio_RecursoPessoal", true);
                            }
                        }
                    },
                    err=>{
                        this.$swal('Aviso', err.message, 'error');
                    }
                )
            }
            else{
                this.AbrirJanela('relatorioRecursoPessoal');
            }            
        },
        LimparFiltros(){
            this.filtro = {
                vincularProjeto: false,
                cargo: null,
                escolaridade: null,
                idProjeto: null,
                idTipoProjeto: null,
                tipoRegime: null,
                ativo: null,
                etnia: null,
                sexo: null,
                adesaoInicial: null,
                adesaoFinal: null,
                exportarExcel: false
            }
        },
        AbrirJanela(rota) {
            let routeLink = this.$router.resolve({ name: rota,
                query:{
                    vincularProjeto: this.filtro.vincularProjeto,
                    cargo: this.filtro.cargo,
                    escolaridade: this.filtro.escolaridade,
                    idProjeto: this.filtro.idProjeto,
                    idTipoProjeto: this.filtro.idTipoProjeto,
                    tipoRegime: this.filtro.tipoRegime,
                    ativo: this.filtro.ativo,
                    etnia: this.filtro.etnia,
                    sexo: this.filtro.sexo,
                    adesaoInicial: this.filtro.adesaoInicial,
                    adesaoFinal: this.filtro.adesaoFinal,

                } 
            });
            window.open(routeLink.href,'_blank');
        },
    },
    mounted(){
        
        this.regimeSerive.Listar().then(
            res=>{
                this.regimes = res.data;
                this.regimes.unshift(
                    {
                        key: null,
                        value: 'TODOS'
                    }
                )
            },
            err=>{
                this.$swal('Aviso', err.message, 'error');
            }
        )
        this.tipoProjetoService.Listar().then(
            res => {
                this.tipoProjetos = res.data.items;
                this.tipoProjetos.unshift(
                    {
                        key: null,
                        nome: 'TODOS'
                    }
                )
            }
        )
        this.etniaService.Listar().then(
            res => {
                this.etnias = res.data;
                this.etnias.unshift(
                    {
                        key: null,
                        value: 'TODAS'
                    }
                )
            }
        )
        this.sexoService.Listar().then(
            res =>{
                this.sexos = res.data;
                this.sexos.unshift(
                    {
                        key: null,
                        value: 'TODOS'
                    }
                )
            }
        )
        this.escolaridadeService.Listar().then(
            res =>{
                this.escolaridades = res.data;
                this.escolaridades.unshift(
                    {
                        key: null,
                        value: 'TODOS'
                    }
                )
            }
        )

    },
    watch: {
        onSearchProjeto(val){
            if(this.isProjetoLoading) return;
            if(this.filtro.idProjeto) return;
            if(!val) return;

            this.isProjetoLoading = true;
            this.projetoService.AutoComplete(val)
            .then(
                res=>{
                    this.projetos = res.data;
                },
                err => this.$swal('Aviso', err.response.data, 'error')
            )
            .finally(() => (this.isProjetoLoading = false))
        }
    }
}

</script>